import { Card, CardContent } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";

export const StrategicOptionsIntro = () => {
  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardContent className="py-4">
        <p className="text-foreground font-semibold">
          Drei Wege — mit sehr unterschiedlichen Konsequenzen.
        </p>
        <p className="text-muted-foreground text-sm mt-1.5">
          Phase 1 hat deinen Fokus geschärft. Jetzt siehst du, welchen Preis jeder Weg kostet.
        </p>
        <div className="flex items-start gap-2 mt-3 p-3 rounded-lg bg-amber-500/10 border border-amber-500/20">
          <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400 mt-0.5 shrink-0" />
          <p className="text-sm text-amber-700 dark:text-amber-300">
            <span className="font-medium">Achtung:</span> Wenn alle Optionen gleich attraktiv wirken, hast du in Phase 1 nicht scharf genug priorisiert.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
